import { useState } from "react";

import { Icon } from "@blueprintjs/core";

import { Button } from "@/components/ui/button";

interface CopyLinkButtonProps {
  text?: string;
  className?: string;
}

export function CopyLinkButton({ className }: CopyLinkButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleClick = async () => {
    if (copied) return;

    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 5000);
    } catch (error) {
      console.error("Failed to copy link:", error);
    }
  };

  return (
    <Button
      intent={copied ? "success" : "secondary"}
      onClick={handleClick}
      className={className}
    >
      <Icon icon={copied ? "tick" : "link"} />
      {copied ? "Copied!" : "Copy Link"}
    </Button>
  );
}
